/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Eficacia de paradas por tramo de tiempo.
 */
export interface TimeIntervalSavesEfficiencyDTO { 
    interval_label: string;
    saves: number;
    goals_against: number;
    total_shots_against: number;
    percentage: number;
}

